<template>
  <a-drawer width="40%" :visible="open" @cancel="onClose" @close="onClose">
    <a-divider orientation="left"><b>{{ formTitle }}</b></a-divider>
    <a-form-model ref="form" :model="form" :rules="rules" :label-col="labelCol" :wrapper-col="wrapperCol">
      <a-form-model-item label="联系人" prop="contactName">
        <a-input v-model="form.contactName" :maxLength="50" />
      </a-form-model-item>
      <a-form-model-item label="联系电话" prop="contactPhone">
        <a-input v-model="form.contactPhone" :maxLength="20" />
      </a-form-model-item>
      <a-form-model-item label="收货地址" prop="address">
        <a-textarea v-model="form.address" :rows="2" :maxLength="200" />
      </a-form-model-item>
      <a-form-model-item label="是否默认" prop="isDefault">
        <a-switch :checked="form.isDefault" @change="(checked) => form.isDefault = checked" />
      </a-form-model-item>
      <a-form-model-item label="状态" prop="status">
        <a-radio-group v-model="form.status">
          <a-radio :value="1">启用</a-radio>
          <a-radio :value="0">禁用</a-radio>
        </a-radio-group>
      </a-form-model-item>
      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm">保存</a-button>
          <a-button @click="cancel">取消</a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>

<script>
import { addAddress, updateAddress } from '@/api/cloudplant/address'

export default {
  name: 'CreateForm',
  data() {
    return {
      labelCol: { span: 6 }, wrapperCol: { span: 16 }, submitLoading: false, formTitle: '', open: false, formType: 1,
      form: { id: null, contactName: null, contactPhone: null, address: null, isDefault: false, status: 1 },
      rules: {
        contactName: [{ required: true, message: '联系人不能为空', trigger: 'blur' }],
        contactPhone: [{ required: true, message: '联系电话不能为空', trigger: 'blur' }],
        address: [{ required: true, message: '收货地址不能为空', trigger: 'blur' }]
      }
    }
  },
  methods: {
    onClose() { this.open = false; this.reset() },
    cancel() { this.open = false; this.reset() },
    reset() { this.formType = 1; this.form = { id: null, contactName: null, contactPhone: null, address: null, isDefault: false, status: 1 } },
    handleAdd() { this.reset(); this.formType = 1; this.open = true; this.formTitle = '添加' },
    handleUpdate(row) { this.reset(); this.formType = 2; this.form = { ...row }; this.open = true; this.formTitle = '修改' },
    submitForm() {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.submitLoading = true
          if (this.form.id) {
            updateAddress(this.form).then(() => { this.$message.success('修改成功'); this.open = false; this.$emit('ok') }).finally(() => { this.submitLoading = false })
          } else {
            addAddress(this.form).then(() => { this.$message.success('新增成功'); this.open = false; this.$emit('ok') }).finally(() => { this.submitLoading = false })
          }
        }
      })
    }
  }
}
</script>
